export const TAX_RATE_PERCENT = 10;
